import {DataGrid} from "@mui/x-data-grid";
//import { GridColDef } from '@mui/x-data-grid';
import { Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem, FormGroup} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {CSVLink} from "react-csv"
import {useEffect, useState} from "react"
import { fetchactiveFd, fetchallFd, fetchdestHotelsbyDest } from "../api/customerapi";
import { useAppData } from "./appDataContext.js";
import GetRole from "./user";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign:"left"
    },
}));

const Listfddata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
//console.log(width);
const columns = [
{ field: 'fd_id', 
  headerName: ' FD ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  { field: 'fd_name', 
  headerName: 'Name', 
  width: width/12*2.5,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'journey_type',
    headerName: 'Type',
    width: width/12*2,
    
  },
  {
    field: 'source_airport',
    headerName: 'Source Airport',
    width: width/12,
    
  },
  {
    field: 'destination_airport',
    headerName: 'Destination Airport',
    width: width/12*1,
  },
  {
    field: 'duration',
    headerName: 'Duration',
    width: width/12*1,
  },
 
  
];

const headers=[
  {label:"Hotel Id", key:"fd_id"},
  {label:"Name", key:"fd_name"},

  
]


var { cuser, role } = GetRole();
const [listfdData, setlistfdData]=useState([]);

  
const getFD = async () => {
  try{
 

    const data = await fetchactiveFd();
   
    setlistfdData(data.data)

 
}catch(err){
  console.log(err)
}
}

const loadallFD = async () => {
    try{
   
    
      const data = await fetchallFd();
     
      setlistfdData(data.data)
  
  
  }catch(err){
    console.log(err)
  }
  }


useEffect(() => {
  getFD()
  
}, [])




  const fddatalistdisplay=listfdData.map(fddata=>({fd_name: fddata.name, 
    fd_id: fddata.fd_id,
    id:listfdData.indexOf(fddata), 
    journey_type:fddata.journey_type,
    source_airport:fddata.source_airport,
    destination_airport:fddata.destination_airport,
    duration:fddata.duration,
  }));
    //console.log(hoteldatalistfromdb);

  const gridcellclick=(id)=>{
    window.open("/fddataentry/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  }

    return ( 
      <div>
      
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View FDs</Typography>
        <Button onClick={loadallFD} variant="contained"  color="inherit" className={classes.button}>Load All</Button>
        {role=="Admin" || role=="Operations-TL" || role=="Product"?(<Button href="/fddataentry" variant="contained" color="primary" className={classes.button}>Add FD</Button>):("")}
        
       
        
        </div>
        {fddatalistdisplay.length>1?(<div>
                   <CSVLink data={fddatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={fddatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.fd_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
  
    </div>
     )
}
 
export default Listfddata;